import { API_BASE_URL } from '../services/api';
import { downloadResponseAsFile } from './downloadFile';
import type { IntakeFilters } from '../hooks/useIntake';

export async function downloadIntakeExport(
  filters: IntakeFilters
): Promise<void> {
  const params = new URLSearchParams();

  if (filters.search) params.set('search', filters.search);
  if (filters.startDate) params.set('start_date', filters.startDate);
  if (filters.endDate) params.set('end_date', filters.endDate);
  if (filters.statuses) {
    for (const s of filters.statuses) {
      params.append('intake_status', s);
    }
  }
  if (filters.clinicId) params.set('clinic_id', filters.clinicId);
  if (filters.assigneeIds) {
    for (const id of filters.assigneeIds) {
      params.append('assignee_ids', id);
    }
  }
  if (filters.assigneeIncludeUnassigned) {
    params.set('include_unassigned', 'true');
  }
  if (filters.sortBy) params.set('sort_by', filters.sortBy);
  if (filters.sortOrder) params.set('sort_order', filters.sortOrder);

  const url = `${API_BASE_URL}/intake/export?${params.toString()}`;
  const response = await fetch(url, { credentials: 'include' });

  if (!response.ok) {
    throw new Error(`Export failed: ${response.status}`);
  }

  await downloadResponseAsFile(response, 'RogerIntakeExport.xlsx');
}
